import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { organizationsAPI } from '../../services/api';

export const fetchOrganizations = createAsyncThunk(
  'organizations/fetchAll',
  async (params = {}) => {
    const response = await organizationsAPI.getAll(params);
    return response.data;
  }
);

export const fetchOrganization = createAsyncThunk(
  'organizations/fetchOne',
  async (id) => {
    const response = await organizationsAPI.getOne(id);
    return response.data;
  }
);

export const createOrganization = createAsyncThunk(
  'organizations/create',
  async (data, { rejectWithValue }) => {
    try {
      const response = await organizationsAPI.create(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const updateOrganization = createAsyncThunk(
  'organizations/update',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await organizationsAPI.update(id, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const deleteOrganization = createAsyncThunk(
  'organizations/delete',
  async (id) => {
    await organizationsAPI.delete(id);
    return id;
  }
);

export const fetchRegions = createAsyncThunk(
  'organizations/fetchRegions',
  async () => {
    const response = await organizationsAPI.getRegions();
    return response.data;
  }
);

export const fetchOrgTypes = createAsyncThunk(
  'organizations/fetchTypes',
  async () => {
    const response = await organizationsAPI.getTypes();
    return response.data;
  }
);

export const fetchOrgStatistics = createAsyncThunk(
  'organizations/fetchStatistics',
  async () => {
    const response = await organizationsAPI.getStatistics();
    return response.data;
  }
);

const organizationsSlice = createSlice({
  name: 'organizations',
  initialState: {
    organizations: [],
    currentOrganization: null,
    regions: [],
    types: [],
    statistics: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCurrentOrganization: (state) => {
      state.currentOrganization = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganizations.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOrganizations.fulfilled, (state, action) => {
        state.loading = false;
        state.organizations = action.payload.results || action.payload;
      })
      .addCase(fetchOrganizations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchOrganization.fulfilled, (state, action) => {
        state.currentOrganization = action.payload;
      })
      .addCase(createOrganization.fulfilled, (state, action) => {
        state.organizations.unshift(action.payload);
      })
      .addCase(updateOrganization.fulfilled, (state, action) => {
        const index = state.organizations.findIndex(o => o.id === action.payload.id);
        if (index !== -1) {
          state.organizations[index] = action.payload;
        }
      })
      .addCase(deleteOrganization.fulfilled, (state, action) => {
        state.organizations = state.organizations.filter(o => o.id !== action.payload);
      })
      .addCase(fetchRegions.fulfilled, (state, action) => {
        state.regions = action.payload.results || action.payload;
      })
      .addCase(fetchOrgTypes.fulfilled, (state, action) => {
        state.types = action.payload.results || action.payload;
      })
      .addCase(fetchOrgStatistics.fulfilled, (state, action) => {
        state.statistics = action.payload;
      });
  },
});

export const { clearCurrentOrganization } = organizationsSlice.actions;
export default organizationsSlice.reducer;
